import FoodAndBeverage from './FoodAndBeverage';
export default FoodAndBeverage;
